import { Action } from '@ngrx/store';

import { HideLoader } from '../../../../shared/decorators/hide-loader';
import { ShowLoader } from '../../../../shared/decorators/show-loader';
import { BaseNotification } from './base-notification.model';

export enum BaseNotificationsActionTypes {
    LoadBaseNotifications = '[BaseNotifications] Load notifications',
    LoadBaseNotificationsSuccess = '[BaseNotifications] Load notifications success',
    LoadBaseNotificationsFail = '[BaseNotifications] Load notifications fail',
    SetBaseNotificationsAsRead = '[BaseNotifications] set as read',
    SetBaseNotificationsAsReadSuccess = '[BaseNotifications] set as read success',
    SetBaseNotificationsAsReadFail = '[BaseNotifications] set as read fail',
}

@ShowLoader()
export class LoadBaseNotifications implements Action {
    type = BaseNotificationsActionTypes.LoadBaseNotifications;
}
@HideLoader(BaseNotificationsActionTypes.LoadBaseNotifications)
export class LoadBaseNotificationsSuccess implements Action {
    readonly type = BaseNotificationsActionTypes.LoadBaseNotificationsSuccess;
    constructor(public payload: BaseNotification[]) { }
}
@HideLoader(BaseNotificationsActionTypes.LoadBaseNotifications)
export class LoadBaseNotificationsFail implements Action {
    readonly type = BaseNotificationsActionTypes.LoadBaseNotificationsFail;
    constructor(public payload: string) { }
}

@ShowLoader()
export class SetBaseNotificationsAsRead implements Action {
    readonly type = BaseNotificationsActionTypes.SetBaseNotificationsAsRead;
    constructor(public id: number) { }
}
@HideLoader(BaseNotificationsActionTypes.SetBaseNotificationsAsRead)
export class SetBaseNotificationsAsReadSuccess implements Action {
    readonly type = BaseNotificationsActionTypes.SetBaseNotificationsAsReadSuccess;
    constructor(public payload: BaseNotification) { }
}
@HideLoader(BaseNotificationsActionTypes.SetBaseNotificationsAsRead)
export class SetBaseNotificationsAsReadFail implements Action {
    readonly type = BaseNotificationsActionTypes.SetBaseNotificationsAsReadFail;
    constructor(public payload: string) { }
}

export type BaseNotificationsAction =
    LoadBaseNotifications | LoadBaseNotificationsSuccess | LoadBaseNotificationsFail
    | SetBaseNotificationsAsRead | SetBaseNotificationsAsReadSuccess | SetBaseNotificationsAsReadFail
    ;
